import * as React from "react";
import { cn } from "@/lib/utils";

export const Checkbox = React.forwardRef<HTMLInputElement, Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & { indeterminate?: boolean }>(
  ({ className, indeterminate, ...props }, ref) => {
    const inner = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => inner.current!);
    React.useEffect(() => {
      if (inner.current) inner.current.indeterminate = !!indeterminate;
    }, [indeterminate]);
    return <input ref={inner} type="checkbox" className={cn("size-4 cursor-pointer rounded accent-[var(--color-primary)]", className)} {...props} />;
  },
);
Checkbox.displayName = "Checkbox";
